import type * as React from 'react';
import { get } from '@Domain/Api';
import beneficiaryContactsFetched, {
	type BeneficiaryContactsFetchedAction,
	type BeneficiaryContactsFetchedPayload,
} from '@Application/Beneficiaries/BeneficiaryContacts/BeneficiaryContacts/Actions/beneficiaryContactsFetched';
import beneficiaryContactsFetchFailed, {
	type BeneficiaryContactsFetchFailedAction,
} from '@Application/Beneficiaries/BeneficiaryContacts/BeneficiaryContacts/Actions/beneficiaryContactsFetchFailed';
import type FetchBeneficiaryContacts from '@Application/Beneficiaries/BeneficiaryContacts/BeneficiaryContacts/Queries/FetchBeneficiaryContacts';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = BeneficiaryContactsFetchedAction | BeneficiaryContactsFetchFailedAction;

export default (query: FetchBeneficiaryContacts) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const url = `${parameters.api.host}/api/facilities/${query.facilityId}/beneficiaries/${query.beneficiaryId}/contacts?${query.toQueryString()}`;

			const payload = await get<BeneficiaryContactsFetchedPayload>(url);

			const action = beneficiaryContactsFetched(payload, query.beneficiaryId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = beneficiaryContactsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
